// For now, this only handles list pathnames, not entity pages.
export function getEntityTypeForPathname(pathname: string) {
    const vanityPath = pathname.split('/')[1];

    switch (vanityPath) {
        case 'people':
            return 'contacts';
        case 'companies':
            return 'accounts';
        default:
            return vanityPath;
    }
}
